
var Model = require("../types/Model.js");
var global = require("global");


module.exports = Model({
	name: "devicebuttons",
	init: init,
	uninit: uninit,

	_onBackKeyDown: null,
});

function init() {
	this._onBackKeyDown = _onBackKeyDown.bind(this);

	if(global.document) {
		global.document.addEventListener("backbutton", this._onBackKeyDown, false);
	}
}

function uninit() {
	if(global.document) {
		global.document.removeEventListener("backbutton", this._onBackKeyDown);
	}
}

function _onBackKeyDown(e) {
	e.preventDefault();
}
